import React, { useState } from 'react'
import "./qualification.css"

const Qualification = () => {
    const [toggleState, setToggleState] = useState(2);

    const toggleTab = (index) => {
        setToggleState(index);
    }

    return (
        <section className='qualification section'>
            <h2 className="section__title">Qualification</h2>
            <span className="section__subtitle">My personal journey</span>

            <div className="qualification__container container">
                <div className="qualification__tabs">
                    <div className={toggleState === 1 ? "qualification__button qualification__active button--flex" : "qualification__button button--flex"}
                        onClick={() => { toggleTab(1) }}
                    >
                        <i className="uil uil-graduation-cap qualification__icon"></i>
                        Education
                    </div>

                    <div className={toggleState === 2 ? "qualification__button qualification__active button--flex" : "qualification__button button--flex"}
                        onClick={() => { toggleTab(2) }}
                    >
                        <i className="uil uil-briefcase-alt qualification__icon"></i>
                        Experience
                    </div>
                </div>

                <div className="qualification__sections">
                    <div className={toggleState === 1 ? "qualification__content qualification__content-active" : "qualification__content"}
                    >

                        <div className="qualification__data">
                            <div>
                                <h3 className="qualification__title">HMR Institute of Technology and Management</h3>
                                <span className="qualification__subtitle">Guru Gobind Singh Indraprastha University</span>

                                <div className="qualification__calender">
                                    <i className="uil uil-calender-alt"></i> 2020 - Present
                                </div>
                            </div>

                            <div>
                                <span className="qualification__rounder"></span>
                                <div className="qualification__line"></div>
                            </div>
                        </div>

                        <div className="qualification__data">
                            <div></div>

                            <div>
                                <span className="qualification__rounder"></span>
                            </div>
                            <div>
                                <h3 className="qualification__title">St. George's School</h3>
                                <span className="qualification__subtitle">New Delhi</span>

                                <div className="qualification__calender">
                                    <i className="uil uil-calender-alt"></i> 2006 - 2020
                                </div>
                            </div>

                        </div>

                    </div>

                    <div className={toggleState === 2 ? "qualification__content qualification__content-active" : "qualification__content"}
                    >

                        <div className="qualification__data">
                            <div>
                                <h3 className="qualification__title">Software Developer Intern</h3>
                                <span className="qualification__subtitle">BotLab Dynamics - IIT Delhi</span>

                                <div className="qualification__calender">
                                    <i className="uil uil-calender-alt"></i> May 2023 - Present
                                </div>
                            </div>

                            <div>
                                <span className="qualification__rounder"></span>
                                <div className="qualification__line"></div>
                            </div>
                        </div>

                        <div className="qualification__data">
                            <div></div>

                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>
                            <div>
                                <h3 className="qualification__title">Python Developer Intern</h3>
                                <span className="qualification__subtitle">BotLab Dynamics - IIT Delhi</span>

                                <div className="qualification__calender">
                                    <i className="uil uil-calender-alt"></i> Nov 2022 - Jan 2023
                                </div>
                            </div>

                        </div>

                        <div className="qualification__data">
                            <div>
                                <h3 className="qualification__title">Software Developer Intern</h3>
                                <span className="qualification__subtitle">Involve Edu</span>

                                <div className="qualification__calender">
                                    <i className="uil uil-calender-alt"></i> Sept 2022 - Dec 2022
                                </div>
                            </div>

                            <div>
                                <span className="qualification__rounder"></span>
                                <div className="qualification__line"></div>
                            </div>
                        </div>

                        <div className="qualification__data">
                            <div></div>

                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>
                            <div>
                                <h3 className="qualification__title">Core Member</h3>
                                <span className="qualification__subtitle">GeeksForGeeks - College</span>

                                <div className="qualification__calender">
                                    <i className="uil uil-calender-alt"></i> Apr 2022 - Nov 2022
                                </div>
                            </div>

                        </div>

                        <div className="qualification__data">
                            <div>
                                <h3 className="qualification__title">Office Bearer</h3>
                                <span className="qualification__subtitle">Pink Legal - College</span>

                                <div className="qualification__calender">
                                    <i className="uil uil-calender-alt"></i> Nov 2021 - Apr 2022
                                </div>
                            </div>

                            <div>
                                <span className="qualification__rounder"></span>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    )
}

export default Qualification